var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterHeaterOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6702 55.1924L50.6704 55.1928L50.6806 55.1849C51.0459 54.8986 51.3537 54.4536 51.3537 53.9206V2.51948C51.3537 1.69019 50.6671 1.0191 49.8307 1.0191H49.8301H10.5083C9.67182 1.0191 8.98529 1.69022 8.98529 2.51948V53.9206C8.98529 54.4409 9.21577 54.8953 9.66943 55.1928C15.7994 59.2792 23.0194 61.3532 30.1695 61.3532C37.3199 61.3532 44.5401 59.2764 50.6702 55.1924ZM48.3072 4.01987V53.1623C37.3459 60.1297 22.9925 60.1297 12.0313 53.1623V4.01987H48.3072Z",
    fill: "url(#paint0_linear_34666_9974)",
    stroke: "url(#paint1_linear_34666_9974)",
    strokeWidth: 0.334113
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1693 44.3522C27.8419 44.3522 25.9345 46.2238 25.9345 48.5193C25.9345 50.8147 27.8419 52.6863 30.1693 52.6863C32.4968 52.6863 34.4042 50.8147 34.4042 48.5193C34.4042 46.157 32.495 44.3522 30.1693 44.3522ZM30.1693 49.6855C29.5121 49.6855 28.9805 49.1587 28.9805 48.5193C28.9805 47.8798 29.5121 47.353 30.1693 47.353C30.8266 47.353 31.3582 47.8798 31.3582 48.5193C31.3582 49.1587 30.8266 49.6855 30.1693 49.6855Z",
    fill: "url(#paint2_linear_34666_9974)",
    stroke: "url(#paint3_linear_34666_9974)",
    strokeWidth: 0.334113
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3471 29.2031L36.3472 29.2031L36.35 29.198C37.4646 27.145 37.3937 24.8148 36.1405 22.8286L36.1405 22.8286L36.1395 22.8271L31.5288 15.6944L31.5289 15.6944L31.5271 15.6918C31.2236 15.2412 30.7619 15.0191 30.2365 15.0191C29.7107 15.0191 29.2494 15.2442 28.9463 15.6914L28.9462 15.6914L28.9443 15.6944L24.3336 22.8271L24.3336 22.8271L24.3326 22.8285C23.082 24.8079 22.9399 27.1414 24.1236 29.1988C25.2413 31.3245 27.6069 32.6864 30.1703 32.6864H30.1704C32.7367 32.6864 35.0985 31.3224 36.3471 29.2031ZM26.6549 27.7008C26.0784 26.6964 26.1374 25.4945 26.7875 24.4068L30.1704 19.2233L33.5542 24.4082C33.5544 24.4085 33.5546 24.4088 33.5548 24.4091C34.2009 25.4273 34.2652 26.6279 33.6833 27.7054L33.683 27.7059C33.0389 28.9083 31.7457 29.6177 30.1704 29.6177C28.6 29.6177 27.3672 28.9117 26.6549 27.7008Z",
    fill: "url(#paint4_linear_34666_9974)",
    stroke: "url(#paint5_linear_34666_9974)",
    strokeWidth: 0.334113
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34666_9974",
    x1: 40.3158,
    y1: 16.6326,
    x2: -16.8581,
    y2: 67.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34666_9974",
    x1: 40.3158,
    y1: 16.6326,
    x2: -16.8581,
    y2: 67.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34666_9974",
    x1: 32.1331,
    y1: 46.5788,
    x2: 24.7122,
    y2: 56.1979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34666_9974",
    x1: 32.1331,
    y1: 46.5788,
    x2: 24.7122,
    y2: 56.1979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34666_9974",
    x1: 33.48,
    y1: 19.6484,
    x2: 16.8578,
    y2: 36.1396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34666_9974",
    x1: 33.48,
    y1: 19.6484,
    x2: 16.8578,
    y2: 36.1396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterHeaterOrangeIcon);
export default __webpack_public_path__ + "static/media/water_heater_orange_icon.c261e0398fcd83bf6622353ae2fdfcd4.svg";
export { ForwardRef as ReactComponent };